'use strict';

var React = require('react');

const ScrollLockManagerContext = /*#__PURE__*/React.createContext(undefined);

exports.ScrollLockManagerContext = ScrollLockManagerContext;
